import React from "react";
import { Button } from "reactstrap";

export default function ConfirmationStep({
  data,
  onBack,
  onConfirm,
  isSending,
  bankName,
}) {
  return (
    <>
      <div style={{ marginBottom: 20 }}>
        Please confirm the information below
      </div>
      <div>
        <Item label="Transfer from" value={bankName} />
        <Item label="To Account ID" value={data.accountId} />
        <Item label="Account name" value={data.accountName} />
        <Item
          label="Currency"
          value={data.currency === "XAU" ? "GOLD" : data.currency}
        />
        <Item label="Amount" value={data.amount} />
        <Item label="From (name)" value={data.fromName} />
        <Item label="From (phone)" value={data.fromPhone} />
        <Item label="Description" value={data.description} />
        <Item label="External reference" value={data.extRef} />
      </div>
      <div>
        <div style={{ marginTop: 20 }}>
          <Button
            type="submit"
            style={{ width: 100 }}
            onClick={onBack}
            disabled={isSending}
            data-cy="back">
            Back
          </Button>
          <Button
            color="primary"
            style={{ marginLeft: 20, width: 100 }}
            onClick={onConfirm}
            disabled={isSending}
            data-cy="submit">
            Send
          </Button>
        </div>
      </div>
    </>
  );
}

function Item({ label, value }) {
  return (
    <div>
      <span style={{ display: "inline-block", width: 120 }}>{label}</span>
      <span style={{ marginRight: 30 }}>:</span>
      <span>{value}</span>
    </div>
  );
}
